import { buildPath } from "../../../helpers/string";
import { root } from "./root";

export const login = {
  path: "login",
  getLink: () => buildPath([root.path, login.path]),
  permissions: [],
};
